import React from "react";
import PropTypes from "prop-types";
import { MultiImageBlock, MultiImageBlockLogoPosition } from "@sunwing/wvi-components";
import { cloudinaryGenURL } from "../../utils/cloudinaryHelpers";
import { ImageConnector } from "../ImageConnector";

const MultiImageBlockConnector = ({ data }) => {
	if (!data?.cloudinaryImages?.length) {
		return null;
	}

	let logoPosition;
	switch (data.logoPosition) {
		case "Top Right":
			logoPosition = MultiImageBlockLogoPosition.topRight;
			break;
		case "Bottom Left":
			logoPosition = MultiImageBlockLogoPosition.bottomLeft;
			break;
		case "Bottom Right":
			logoPosition = MultiImageBlockLogoPosition.bottomRight;
			break;
		case "Top Left":
		default:
			logoPosition = MultiImageBlockLogoPosition.topLeft;
			break;
	}

	const images = data.cloudinaryImages.map((image, index) => ({
		id: index.toString(),
		...cloudinaryGenURL({
			cloudinaryImage: image,
			maxWidth: 1600,
			title: image.title,
			desc: image.title,
			disableAutoGravity: true,
		}),
	}));

	return (
		<MultiImageBlock
			images={images}
			logo={
				data.logo?.[0] && {
					...cloudinaryGenURL({
						cloudinaryImage: data.logo?.[0],
						title: data.title,
						maxWidth: 400,
					}),
				}
			}
			logoPosition={logoPosition}
			populateImagesRightToLeft={data.populateImagesRightToLeft}
			populateImagesAsRows={data.populateImagesAsRows}
			columnProportions={data.columnProportions}
			photoCredit={data.photoCredit}
			// eslint-disable-next-line react/jsx-props-no-spreading
			renderImage={(image, props) => <ImageConnector image={image} {...props} />}
		/>
	);
};

MultiImageBlockConnector.propTypes = {
	data: PropTypes.shape({
		cloudinaryImages: PropTypes.arrayOf(
			PropTypes.shape({
				format: PropTypes.string,
				height: PropTypes.number,
				width: PropTypes.number,
				version: PropTypes.number,
				public_id: PropTypes.string,
				raw_transformation: PropTypes.string,
				secure_url: PropTypes.string,
				url: PropTypes.string,
			})
		).isRequired,
		logo: PropTypes.arrayOf(
			PropTypes.shape({
				format: PropTypes.string,
				height: PropTypes.number,
				width: PropTypes.number,
				version: PropTypes.number,
				public_id: PropTypes.string,
				raw_transformation: PropTypes.string,
				secure_url: PropTypes.string,
				url: PropTypes.string,
			})
		),
		logoPosition: PropTypes.oneOf(["Top Left", "Top Right", "Bottom Left", "Bottom Right"]),
		populateImagesRightToLeft: PropTypes.bool,
		populateImagesAsRows: PropTypes.bool,
		columnProportions: PropTypes.oneOf(["1/2", "2/3", "3/4"]),
		photoCredit: PropTypes.string,
		title: PropTypes.string,
	}).isRequired,
};

export { MultiImageBlockConnector };
